import React from 'react';
// import { useNavigate } from 'react-router-dom';
import './../growth-tracking.scss';
import ContentLibraryImg from './../assets/feature showcase/1 Content Library Mock.png';
import AnalyticsImg from './../assets/feature showcase/2 Analytics Mock-Up.png';
import DashboardImg from './../assets/feature showcase/3 My Dashboard Mock.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import ButtonControl from '../../../components/controls/ButtonControl';

const GrowthTracking = () => {
  // const navigate = useNavigate();
  return (
    <div className='growth-tracking' role="region" aria-label="Growth Tracking">
      <div className='growth-tracking-container'>

        <div className='growth-info-container'>
          {/* 7.2/7.5: promoted from a plain <div> to a real <h2> - gives this section a proper
              heading (was previously unannounced to "navigate by heading" screen reader users)
              and lets the feature list below be labelled by it via aria-labelledby. Also fixes
              the page's heading hierarchy: this section now nests under the page's single <h1>
              (Main.js hero) as an <h2>, matching Trending Content/Testimonials/FAQ. */}
          <h2 className='growth-header' id='growth-tracking-heading'>
            {/* Personalized Growth Tracking */}
            Why EE PASS?
          </h2>
          <div>
            {/* 7.2: feature list already used <ul>/<li> with aria-hidden decorative check
                icons; added `aria-labelledby` (referencing the heading above) so the list
                itself has a descriptive accessible name/label, and the items are already in a
                logical, non-arbitrary order (each builds on the previous: instructional
                modeling -> feedback -> deepening impact -> evaluation consistency). */}
            <ul className='list-container' aria-labelledby='growth-tracking-heading'>
              <li><FontAwesomeIcon icon={faCheck} className='check' aria-hidden="true" />See Effective Instruction: Full lessons and targeted video clips that make expectations clear and give teachers a concrete model to replicate.</li>
              <li><FontAwesomeIcon icon={faCheck} className='check' aria-hidden="true" />Strengthen Teacher Feedback: Enter and analyze observation data in a system that informs next steps for teachers.</li>
              <li><FontAwesomeIcon icon={faCheck} className='check' aria-hidden="true" />Deepen Instructional Impact: Self-paced, research-backed learning modules that build a shared understanding of effective instruction.</li>
              <li><FontAwesomeIcon icon={faCheck} className='check' aria-hidden="true" />Build Consistency in Evaluations: Providing resources that strengthen learning and credentialing of observation and feedback.</li>
            </ul>
          </div>
          <div className='growth-intro'>
            From our coaching hub to our data management and evaluator training capabilities, EE PASS supports every role from classroom teachers to coaches, principals, and district administrators.
          </div>
          {/* <div className='growth-intro'>
            Visual analytics that allow for quick identification of progress, performance, and professional development areas.
          </div>
          <div>
            <ul className='list-container'>
              <li><FontAwesomeIcon icon={faCheck} className='check' />Observation Process Feedback</li>
              <li><FontAwesomeIcon icon={faCheck} className='check' />Interactive Charts</li>
              <li><FontAwesomeIcon icon={faCheck} className='check' />Progress Toward Certification</li>
              <li><FontAwesomeIcon icon={faCheck} className='check' />Export Real-Time Data</li>
            </ul>
          </div> */}

        </div>
        <div className='image-wrapper'>
          <img src={ContentLibraryImg} className="image-1" alt="Content Library" />
          <img src={AnalyticsImg} className="image-2" alt="Analytics" />
          <img src={DashboardImg} className="image-3" alt="Dashboard" />
        </div>
      </div>
    </div>
  );
}

export default GrowthTracking;